import { ProductAdjustmentTypeEnum } from 'common/constants/enum';
import { Translate } from 'next-translate';

const productAdjustmentTypeOptions = (t: Translate) => [
  {
    id: ProductAdjustmentTypeEnum.In,
    label: t('enum:in'),
  },
  {
    id: ProductAdjustmentTypeEnum.Out,
    label: t('enum:out'),
  },
];

export default productAdjustmentTypeOptions;
